<template>
  <div class="news-detail">
    <div>
      <div class="content" v-html="content">
      </div>
      <div class="change">
        <p v-if="currentId > 0">
          上一篇 <span @click="change(0)"> {{ previous }} </span>
        </p>
        <p v-if="currentId < newsList.length - 1">
          下一篇 <span @click="change(1)"> {{ next }} </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import '../assets/css/newsDetail.less'

export default {
  name: 'index',
  data() {
    return {
      currentId: 0,
      previous: '',
      next: '',
      content: '',
      noticeId: '',
      list: [],
      newsList: []
    }
  },
  methods: {
    change(val) {
      if (val === 0) {
        this.currentId--
      } else {
        this.currentId++
      }
      this.getDetail(this.newsList[this.currentId].noticeId)
      if (this.currentId >= 1) {
        this.previous = this.newsList[this.currentId - 1].noticeTitle
      }
      if (this.currentId < this.newsList.length - 1) {
        this.next = this.newsList[this.currentId + 1].noticeTitle
      }
      window.scrollTo(0, 0)
    },
    // 获取详情
    getDetail(id) {
      var params = new URLSearchParams();
      // params.append('cid', sessionStorage.getItem("cid"))
      // params.append('type', '1')
      axios.get('/system/notice/' + id, params).then(res => {
        if (res.data.code == 200) {
          this.content = res.data.data.noticeContent
        }
      }, err => { })
    }
  },
  mounted() {
    this.noticeId = sessionStorage.getItem('noticeId')
    this.getDetail(this.newid)
  },
};
</script>

<style lang="less">

</style>
